import { render, staticRenderFns } from "./ManagementTeam.vue?vue&type=template&id=663add8d&scoped=true"
import script from "./ManagementTeam.vue?vue&type=script&lang=js"
export * from "./ManagementTeam.vue?vue&type=script&lang=js"
import style0 from "./ManagementTeam.vue?vue&type=style&index=0&id=663add8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663add8d",
  null
  
)

export default component.exports